import * as React from "react";
import { PostCodeAnywhereSearchEditor } from "../../../react-core/Html/Address/PostCodeAnywhereSearchEditor";
import { TextBoxEditor } from "../../../react-core/Html/TextBoxEditor";
import { UkPostCode } from "../../../react-core/Html/Validation/RegExPatterns";
import { CountryCode } from "../../../Wrap/Constants/Enums/Domain/CountryCode";
import { Address as AddressModel } from "../../../Wrap/Models/Domains/Address/Address";
import { IProcessComponentProps, ProcessComponent } from "../Process/Process/ProcessComponent";

export interface IAddressProps extends IProcessComponentProps {
    data: AddressModel;
    required: boolean;
}

export interface IAddressState {}

export class Address extends ProcessComponent<IAddressProps, IAddressState> {
    constructor(props: any) {
        super(props);
    }

    private onAddressChange(changes) {
        let { data } = this.props;
        const _data = JSON.parse(JSON.stringify(data || {}));
        if (!_data) {
            data = this.emptyAddress();
        }
        for (const key in changes) {
            _data[key] = changes[key];
        }
        this.props.onChange(_data);
    }

    render() {
        const { data, required } = this.props;
        return (
            <>
                <PostCodeAnywhereSearchEditor
                    onLookupError={() => {}}
                    onAddressSelected={(v) => {
                        this.props.onChange({
                            Line1: v.Line1,
                            Line2: v.Line2,
                            Line3: v.Line3,
                            Postcode: v.Postcode,
                        });
                    }}
                    countryCode={CountryCode.GBR}
                    label={`Address `}
                />
                <TextBoxEditor
                    label={`Address line 1`}
                    value={data?.Line1}
                    required={required ? "Please enter Address Line1" : null}
                    onChange={(v) => this.onAddressChange({ Line1: v })}
                />
                <TextBoxEditor
                    label={`Address line 2`}
                    value={data?.Line2}
                    required={required ? "Please enter Address Line2" : null}
                    onChange={(v) => this.onAddressChange({ Line2: v })}
                />
                <TextBoxEditor
                    label="Address line 3"
                    value={data?.Line3}
                    maxLength={35}
                    onChange={(v) => this.onAddressChange({ Line3: v })}
                />
                <TextBoxEditor
                    label="Postcode"
                    value={data?.Postcode}
                    required={required ? "Please enter postcode" : null}
                    regex={{ errorMessage: "Please enter valid postcode", value: UkPostCode }}
                    onChange={(v) => this.onAddressChange({ Postcode: v })}
                />
            </>
        );
    }
    private emptyAddress(): AddressModel {
        return { Line1: null, Line2: null, Line3: null, Line4: null, Postcode: null };
    }
}
